import { render } from "./attendbox.vue?vue&type=template&id=7aea23eb&scoped=true"
import script from "./attendbox.vue?vue&type=script&lang=js"
export * from "./attendbox.vue?vue&type=script&lang=js"

import "./attendbox.vue?vue&type=style&index=0&id=7aea23eb&scoped=true&lang=css"

import exportComponent from "/home/chris/tw/src/attendctrl/attend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aea23eb"]])

export default __exports__